import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import {
  DocumentRequest,
  DownloadDocumentsClientResponse,
} from '../../@types/DownloadDocuments'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { api } from '../../Services/API'
import { useRunPetisSimulationStore } from '../../Stores/useRunPetisSimulationStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { t } from '../../i18n'
import { downloadFile } from '../../utils/downloadFile'
import { useErrorRequest } from '../useErrorRequest'

type DocumentDownloadType = {
  documents: DocumentRequest[]
  documentName?: string
  useFileExtension?: boolean
}

const request = async (payload: DocumentRequest[]) => {
  const { data } = await api.post<DownloadDocumentsClientResponse>(
    API_ROUTES.downloadDocument,
    { documents: payload },
  )

  return data
}

export const useDownloadFileDocument = () => {
  const { runPetisSimulation } = useRunPetisSimulationStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: DocumentDownloadType) => request(payload.documents),
    onSuccess(data, variables) {
      downloadFile(
        data.documents?.[0].documentContent as string,
        variables.documentName ||
          runPetisSimulation?.runPetisSimulationResponse?.quoteId!,
        variables.useFileExtension,
      )
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ message: t('general.errors.download'), error })
    },
  })
}
